import { selectCountries } from "../../../../../components/appData.slice";
import { FormElement, FormId } from "../../../../../components/enums";
import {
  ComplexFormSchemaComponents,
  FormSchema,
  SimpleFormSchemaComponents,
} from "../../../../../components/types";
import { provinces } from "../../../../../shared";
import {
  selectCountry,
  selectIsDefaultCountrySelected,
  selectIsNotDefaultCountrySelected,
} from "../../../../../store/HOC/genericUI.selectors";
import { peselMask, postalCodeMask } from "../../../../../utilities/masks";
import {
  selectShouldDisplayPerson,
  selectUIData,
  selectVehicleOwnerPersonData,
  selectShouldNotValidateByPesel,
  selectVehicleOwnerAvailableCities,
} from "../vehicleOwner.selectors";
import {
  setUIField,
  setUIObjectField,
  setLackOfPesel,
  setApplicantIsOwner,
  setAvailableCities,
} from "../vehicleOwner.slice";

import { ComponentId } from "./enums";

export const form: FormSchema<
  ComplexFormSchemaComponents | SimpleFormSchemaComponents
> = {
  formId: FormId.VEHICLE_OWNER_PERSON_DATA,
  selector: selectVehicleOwnerPersonData,
  isVisible: selectShouldDisplayPerson,
  content: [
    {
      sections: [
        {
          title: "Dane właściciela",
          id: "ApplicantIsOwner",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.CHECKBOX,
              id: ComponentId.APPLICANT_IS_OWNER,
              label: "",
              onChange: setApplicantIsOwner,
              items: [
                {
                  label: "Zgłaszający jest właścicielem",
                  value: "true",
                },
              ],
            },
          ],
        },
        {
          id: "vehicle-owner-person-details-1",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.INPUT,
              id: ComponentId.NAME,
              label: "Imię",
              onChange: setUIObjectField,
              required: true,
            },
            {
              type: FormElement.INPUT,
              id: ComponentId.SURNAME,
              label: "Nazwisko",
              onChange: setUIObjectField,
              required: true,
            },
          ],
        },
        {
          id: "vehicle-owner-person-details-2",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.PHONE,
              country: selectCountry(selectUIData)("ownerPersonphone"),
              id: ComponentId.PHONE,
              onChange: setUIObjectField,
              label: "Telefon",
              required: true,
            },
            {
              type: FormElement.INPUT,
              id: ComponentId.EMAIL,
              label: "Email",
              onChange: setUIObjectField,
              tooltip:
                "Jeśli nie poda Pan/Pani adresu email, korespondencja będzie wysyłana pocztą, a czas likwidacji może się wydłużyć. Nie wykorzystamy maila do wysyłania pism innych niż związane ze szkodą.",
              required: true,
            },
          ],
        },
        {
          id: "vehicle-owner-company-details-3",
          wrapper: { xs: 6 },
          components: [
            {
              type: FormElement.INPUT,
              id: ComponentId.PESEL,
              mask: peselMask,
              disabled: selectShouldNotValidateByPesel,
              label: "PESEL",
              required: true,
            },
          ],
        },
        {
          id: "vehicle-owner-company-details-3a",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.CHECKBOX,
              id: ComponentId.PERSON_DATA_LACK_OF_PESEL,
              label: "",
              onChange: setLackOfPesel,
              items: [
                {
                  label: "Brak numeru PESEL",
                  value: "true",
                },
              ],
            },
          ],
        },
        {
          title: "Adres właściciela",
          id: "vehicle-owner-company-details-4",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.INPUT,
              id: ComponentId.STREET,
              label: "Ulica",
              required: true,
            },
            {
              type: FormElement.INPUT,
              id: ComponentId.STREET_2,
              label: "Numer budynku / mieszkania",
              required: true,
            },
          ],
        },
        {
          id: "vehicle-owner-company-details-5",
          wrapper: { xs: 12 },
          components: [
            {
              isVisible: selectIsNotDefaultCountrySelected(selectUIData)(
                "ownerCompany[country]"
              ),
              type: FormElement.ZIP_CODE,
              mask: postalCodeMask,
              id: ComponentId.ZIP_CODE_PL,
              label: "Kod pocztowy",
              // LPPLWEBMOB-728
              onChange: setAvailableCities,
            },
            {
              isVisible: selectIsDefaultCountrySelected(selectUIData)(
                "ownerCompany[country]"
              ),
              type: FormElement.INPUT,
              id: ComponentId.ZIP_CODE_GENERIC,
              label: "Kod pocztowy",
            },
            // LPPLWEBMOB-728
            {
              isVisible: selectIsNotDefaultCountrySelected(selectUIData)(
                "ownerCompany[country]"
              ),
              type: FormElement.SELECT_CITY,
              id: ComponentId.CITY,
              label: "Miejscowość",
              items: [],
              selectAvailableCities: selectVehicleOwnerAvailableCities,
              required: true,
            },
            {
              isVisible: selectIsDefaultCountrySelected(selectUIData)(
                "ownerCompany[country]"
              ),
              type: FormElement.INPUT,
              id: ComponentId.CITY,
              label: "Miejscowość",
              required: true,
            },
          ],
        },
        {
          id: "vehicle-owner-company-details-6",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.AUTOCOMPLETE,
              id: ComponentId.COUNTRY,
              onChange: setUIField,
              items: selectCountries,
              required: true,
              label: "Kraj",
            },
            {
              type: FormElement.SELECT,
              id: ComponentId.PROVINCE,
              disabled: selectIsDefaultCountrySelected(selectUIData)(
                "ownerPerson[country]"
              ),
              label: "Województwo",
              items: [...provinces],
            },
          ],
        },
        {
          id: "vehicle-owner-company-details-7",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.RADIO,
              id: ComponentId.COOWNER,
              required: true,
              label:
                "Czy w dowodzie rejestracyjnym pojazdu widnieje współwłaściciel?",
              items: [
                {
                  label: "tak",
                  value: "true",
                },
                {
                  label: "nie",
                  value: "false",
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};
